import React, { useState, useEffect, useContext } from "react";
import { Container, Spinner } from "react-bootstrap";
import ActionComp from "../layouts/ActionComp";
import BreadcrumbComp from "../layouts/BreadcrumbComp";
import GridMaster from "./GridMaster";
import StatusRenderer from "./StatusRenderer.jsx";
import ActionRenderer from "./ActionRenderer";
import { getActiveCustomers } from "../../services/customer-service";
import { exportToExcel } from "../utils/ExcelCreation";
import ViewCustomerMaster from "./ViewCustomerMaster";
import { useDispatch } from "react-redux";
import { menuActions } from "../../store/menu-slice";
import { searchActions } from "../../store/grid-slice";
import { sortByPropertyInAscending } from "../../utils/Utility";
import { AuthContext } from "../../contexts/AuthContext";
import { addLogDetails } from "../../services/logger-entry-service";
import GridMasterInfiniteMode from "./GridMasterInfiniteMode.jsx";
import axios from "axios";

const CustomerMaster = () => {
  const context = useContext(AuthContext);
  const userDetails = {
    email: context.userEmail,
    userName: context.userName,
    role: context.role,
    userId: context.userId,
  };
  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [resetFilter, setResetFilter] = useState(true);
  const [loading, setLoading] = useState(true);
  const [filteredResulttemp, setFilteredResulttemp] = useState([]);
  const [filterColLength, setFilterColLength] = useState(0);

  const dispatch = useDispatch();
  dispatch(menuActions.setMenu("Customer Master"));

  const columnDefs = [
    {
      headerName: "BP Code",
      field: "CustomerCode",
      width: 80,
      tooltipField: "CustomerCode",
    },
    {
      headerName: "BP Name",
      field: "CustomerName",
      tooltipField: "CustomerName",
      width: 150,
    },
    {
      headerName: "Address",
      field: "Address",
      width: 350,
      tooltipField: "Address",
    },
    {
      headerName: "Zip Code/ Postal Code",
      field: "PinCode",
      width: 120,
      tooltipField: "PinCode",
    },
    {
      headerName: "City",
      field: "City",
      width: 100,
      tooltipField: "City",
    },
    {
      headerName: "Email",
      field: "EmailId",
      width: 150,
      tooltipField: "EmailId",
    },
    {
      field: "",
      maxWidth: 80,
      cellRenderer: function (params) {
        return (
          <ActionRenderer
            selectedData={params.data}
            handleViewEvent={handleView}
          />
        );
      },
      sortable: false,
      filter: false,
      pinned: "right",
      resizable: false,
    },
  ];

  const headerName = (field) => {
    let name;
    switch (field) {
      case "CustomerCode":
        name = "BP Code";
        break;
      case "CustomerName":
        name = "BP Name";
        break;
      case "Address":
        name = "Address";
        break;
      case "PinCode":
        name = "Zip Code/ Postal Code";
        break;
      case "City":
        name = "City";
        break;
      case "EmailId":
        name = "Email";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const fieldName = (header) => {
    let name;
    switch (header) {
      case "BP Code":
        name = "CustomerCode";
        break;
      case "BP Name":
        name = "CustomerName";
        break;
      case "Address":
        name = "Address";
        break;
      case "Zip Code/ Postal Code":
        name = "PinCode";
        break;
      case "City":
        name = "City";
        break;
      case "Email":
        name = "EmailId";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const fetchCustomerMaster = async () => {
    let allResults = [];
    let lastEvaluatedKey = null;
    let batchCount = 0;
    const BATCH_SIZE = 2000;

    // setLoading(true);
    dispatch(searchActions.setSearch(""));

    try {
      do {
        batchCount++;
        console.log(`Fetching batch ${batchCount}...`);

        const batch = await getActiveCustomers(BATCH_SIZE, lastEvaluatedKey);

        // Combine results
        allResults = [...allResults, ...batch.items];
        lastEvaluatedKey = batch.lastEvaluatedKey;

        // Update UI immediately with current batch
        const sortedResults = [...allResults]
          .sort(sortByPropertyInAscending("BodStatus"))
          .sort((a, b) => {
            if (a.BodStatus === b.BodStatus) {
              return sortByPropertyInAscending("CustomerCode")(a, b);
            }
            return 0;
          });

        setFilteredResult(sortedResults);
        setExcelData(sortedResults);

        console.log(
          `Batch ${batchCount} loaded: ${batch.items.length} records (Total: ${allResults.length})`,
        );

        // Small delay to prevent UI blocking
        await new Promise((resolve) => setTimeout(resolve, 50));
      } while (lastEvaluatedKey);

      // Final sort after all data loaded
      const finalResults = allResults
        .sort(sortByPropertyInAscending("BodStatus"))
        .sort((a, b) => {
          if (a.BodStatus === b.BodStatus) {
            return sortByPropertyInAscending("CustomerCode")(a, b);
          }
          return 0;
        });

      setFilteredResult(finalResults);
      setExcelData(finalResults);
      setResetFilter(!resetFilter);

      console.log(`All data loaded: ${allResults.length} total records`);
    } catch (error) {
      console.error("Error fetching customer master data:", error);
    } finally {
      // setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchCustomerMaster();
  // }, [reload]);

  const handleView = async (row) => {
    // setLoading(true);
    let tempUnique = "SK#" + row.SK;
    await addLogDetails(
      row,
      "View",
      tempUnique,
      "CustomerMasterLog",
      userDetails,
      "Master",
    );
    setAction("View");
    setRowData(row);
    setShowForm(true);
    // setLoading(false);
  };

  const handleGlobalExport = async () => {
    let filename = "Customer_Master";
    let excelDownoadData = [];

    excelData.forEach((element) => {
      excelDownoadData.push({
        BPCode: element.CustomerCode,
        BPName: element.CustomerName,
        Address: element.Address,
        PinCode: element.PinCode,
        City: element.City,
        EmailId: element.EmailId,
      });
    });

    let colName = [
      "BP Code",
      "BP Name",
      "Address",
      "Zip Code/ Postal Code",
      "City",
      "Email",
    ];
    let Fieldname = [
      "BPCode",
      "BPName",
      "Address",
      "PinCode",
      "City",
      "EmailId",
    ];
    exportToExcel(
      filename,
      "Data",
      excelDownoadData,
      "A1:F1",
      colName,
      Fieldname,
    );
  };
  const getCustomerData = async (apiParams) => {
    console.log("Inside getCustomerData :: ", apiParams);
    const API_URL = process.env.REACT_APP_API_URL;
    const response = await axios.post(
      `${API_URL}/customermaster/getactivecustomers`,
      apiParams,
    );
    console.log("Inside response :: ", response);
    return response;
  };
  return (
    <>
      {/* {loading && (
        <div className="spinner-box">
          {" "}
          <Spinner animation="border" className="spinner" />
        </div>
      )} */}
      <BreadcrumbComp />
      <Container fluid className="main-container">
        <ActionComp exportEvent={() => handleGlobalExport()} export={false} />
        <GridMasterInfiniteMode
          rowDetails={filteredResult}
          colDetails={columnDefs}
          fieldNames={fieldName}
          headerNames={headerName}
          getDataEvent={(getFilteredData) =>
            setFilteredResulttemp(getFilteredData)
          }
          getFilterColLength={(getLength) => setFilterColLength(getLength)}
          // setExcelData={setExcelData}
          handleView={handleView}
          resetind={resetFilter}
          getData={getCustomerData}
        />

        {showForm && (
          <ViewCustomerMaster
            show={showForm}
            action={action}
            rowdata={rowData}
            onHide={() => setShowForm(false)}
            setReload={setReload}
            // reload={reload}
          />
        )}
      </Container>
    </>
  );
};

export default CustomerMaster;

// import React, { useRef, useMemo, useState } from "react";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import { getActiveCustomers } from "../../services/customer-service";
// import axios from "axios";
// import ActionRenderer from "./ActionRenderer";

// const CustomerMaster = () => {
//   // We need to keep track of the LastEvaluatedKey for each "block"
//   const lastKeyRef = useRef(null);
//   const gridRef = useRef(null);
//   const API_URL = process.env.REACT_APP_API_URL;

//   const columnDefs = [
//     {
//       headerName: "BP Code",
//       field: "CustomerCode",
//       width: 80,
//       tooltipField: "CustomerCode",
//       filter: "agTextColumnFilter",
//       filterParams: { debounceMs: 500 }, // Waits 500ms after typing stops
//     },
//     {
//       headerName: "BP Name",
//       field: "CustomerName",
//       tooltipField: "CustomerName",
//       width: 150,
//       filter: "agTextColumnFilter",
//       filterParams: { debounceMs: 500 }, // Waits 500ms after typing stops
//     },
//     {
//       headerName: "Address",
//       field: "Address",
//       width: 350,
//       tooltipField: "Address",
//       filter: "agTextColumnFilter",
//       filterParams: { debounceMs: 500 }, // Waits 500ms after typing stops
//     },
//     {
//       headerName: "Zip Code/ Postal Code",
//       field: "PinCode",
//       width: 120,
//       tooltipField: "PinCode",
//       filter: "agTextColumnFilter",
//       filterParams: { debounceMs: 500 }, // Waits 500ms after typing stops
//     },
//     {
//       headerName: "City",
//       field: "City",
//       width: 100,
//       tooltipField: "City",
//       filter: "agTextColumnFilter",
//       filterParams: { debounceMs: 500 }, // Waits 500ms after typing stops
//     },
//     {
//       headerName: "Email",
//       field: "EmailId",
//       width: 150,
//       tooltipField: "EmailId",
//       filter: "agTextColumnFilter",
//       filterParams: { debounceMs: 500 }, // Waits 500ms after typing stops
//     },
//     // {
//     //   field: "",
//     //   maxWidth: 80,
//     //   cellRenderer: function (params) {
//     //     return <ActionRenderer selectedData={params.data} handleViewEvent="" />;
//     //   },
//     //   sortable: false,
//     //   filter: false,
//     //   pinned: "right",
//     //   resizable: false,
//     // },
//   ];
//   const pageSize = 7;
//   const dataFetchLimit = 100;
//   const onGridReady = (params) => {
//     const dataSource = {
//       getRows: async (getRowParams) => {
//         // Show overlay if this is the first load or a slow search
//         params.api.showLoadingOverlay();
//         try {
//           if (getRowParams.startRow === 0) {
//             lastKeyRef.current = null;
//           }

//           let allFetchedItems = [];

//           let currentLastKey = lastKeyRef.current;
//           let scanCount = 0;
//           const MAX_SCANS = 10; // Safety break to prevent infinite loops

//           console.log(
//             "allFetchedItems length Before Loop :: ",
//             allFetchedItems.length,
//             "\t scanCount :: ",
//             scanCount,
//             "\t MAX_SCANS :: ",
//             MAX_SCANS,
//             "\n",
//             allFetchedItems,
//           );
//           // Keep fetching until we find some items OR hit the end OR hit safety limit
//           while (allFetchedItems.length < pageSize) {
//             const apiParams = {
//               limit: dataFetchLimit,
//               lastEvaluatedKey: currentLastKey || "",
//               filterModel: getRowParams.filterModel,
//             };

//             const response = await axios.post(
//               `${API_URL}/customermaster/getactivecustomers`,
//               apiParams,
//             );
//             const newItems = response.data.items || [];
//             allFetchedItems = [...allFetchedItems, ...newItems]; // ACCUMULATE, don't replace
//             currentLastKey = response.data.lastEvaluatedKey;
//             scanCount++;
//             console.log(
//               "scanCount :: ",
//               scanCount,
//               "\t currentLastKey :: ",
//               currentLastKey,
//               "\t allFetchedItems.length :: ",
//               allFetchedItems.length,
//             );
//             // If no more data in DynamoDB, stop searching
//             if (!currentLastKey) break;
//           }

//           // Update the ref for the NEXT time AG Grid calls getRows
//           lastKeyRef.current = currentLastKey;
//           console.log(
//             "getRowParams.startRow :: ",
//             getRowParams.startRow,
//             "\nallFetchedItems length :: ",
//             allFetchedItems.length,
//             "\n",
//             allFetchedItems,
//           );
//           params.api.hideOverlay(); // Hide once data is ready
//           // If we found NO items and there is NO more data, it's truly the end.
//           // If we have items or more data, tell AG Grid to keep the scroll active.
//           let lastRow = -1;
//           if (!currentLastKey && allFetchedItems.length < pageSize) {
//             lastRow = getRowParams.startRow + allFetchedItems.length;
//           }
//           console.log("lastRow :: ", lastRow);
//           getRowParams.successCallback(allFetchedItems, lastRow);
//         } catch (error) {
//           getRowParams.failCallback();
//         }
//       },
//     };
//     console.log("dataSource :: ", dataSource);
//     params.api.setDatasource(dataSource);
//   };

//   return (
//     <div className="ag-theme-alpine agGridContainer d-none d-md-block d-lg-block">
//       <AgGridReact
//         ref={gridRef}
//         columnDefs={columnDefs}
//         rowModelType="infinite" // Critical for large datasets
//         cacheBlockSize={pageSize} // How many rows to fetch per request
//         onGridReady={onGridReady}
//         pagination={true}
//         paginationPageSize={pageSize} // e.g., 100
//         rowHeight={40}
//         headerHeight={40}
//         rowSelection={"multiple"}
//         enableBrowserTooltips={true}
//         domLayout="autoHeight"
//         // maxBlocksInCache={10} // Prevents memory issues with 3L records
//         // Tell the grid to assume there are at least 1000 rows so the scrollbar appears
//         // infiniteInitialRowCount={100}
//         // How many rows to "peek" ahead to keep the scrollbar moving
//         // cacheOverflowSize={2}
//       />
//     </div>
//   );
// };

// export default CustomerMaster;
